// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MoneyFragmentDoc } from '../../graphql/api/fragments/money.fragment.generated';
export const TaxSnippetFragmentDoc = `
    fragment taxSnippet on SalePrice {
  __typename
  total {
    ...money
  }
  tax {
    type
  }
}
    `;